import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import VideoPlayer from "./VideoPlayer";
import { YoutubeWatchButton } from "./WatchActions";
import { getYoutubeId } from "../lib/api";

export default function VideoModal({ open, onClose, video }) {
  if (!video) return null;
  const hasYoutube = Boolean(getYoutubeId(video.youtubeUrl));

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.92, y: 20, opacity: 0 }}
            transition={{ type: "spring", damping: 24, stiffness: 260 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-4xl rounded-2xl overflow-hidden border border-[rgba(168,85,247,0.35)] bg-[#0a0b16] shadow-[0_30px_90px_-20px_rgba(139,92,246,0.6)]"
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 z-10 w-10 h-10 rounded-full bg-black/60 hover:bg-black/90 flex items-center justify-center text-white transition-colors"
            >
              <X size={20} />
            </button>

            <div className="relative aspect-video bg-black">
              <VideoPlayer video={video} autoplay />
            </div>

            <div className="p-5 md:p-6">
              {video.programName && <span className="tv-badge mb-3">{video.programName}</span>}
              <h3 className="text-xl font-bold text-white font-display">{video.title}</h3>
              <p className="text-[var(--tv-muted)] mt-2 text-sm leading-relaxed">{video.description}</p>
              <div className="flex items-center gap-4 mt-4 text-xs text-[var(--tv-muted)]">
                {video.publishedAt && <span>{video.publishedAt}</span>}
                {video.views && <span>• {video.views}</span>}
                {video.duration && <span>• {video.duration}</span>}
              </div>
              {hasYoutube && (
                <div className="mt-4">
                  <YoutubeWatchButton url={video.youtubeUrl} className="!px-4 !py-2 text-xs" />
                </div>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
